import { render, staticRenderFns } from "./Sudlarda.vue?vue&type=template&id=4e6684df&scoped=true&"
import script from "./Sudlarda.vue?vue&type=script&lang=js&"
export * from "./Sudlarda.vue?vue&type=script&lang=js&"
import style0 from "./Sudlarda.vue?vue&type=style&index=0&id=4e6684df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6684df",
  null
  
)

export default component.exports